<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'inventory-otherInbound',
  components: {
    PageTable,
  },
}
</script>